import React, { useMemo } from "react";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";
import VehicleCard from "../vehicleCard/vehicleCard";
import { SidebarProps, VehicleData } from "../../../models/monitorView/monitorViewTypes";
import VehicleFilters from "../vehicleCard/vehicleFilters";
import VehicleGroupFilter from "../sidebar/filters/vehicleGroupFilter";
import { useAppSelector } from "../../../framework/customStore";
import { setSelectedVehicleGroupIds } from "../../../store/monitorViewFiltersSlice";
import { Grid } from "@mui/material";

export const MonitorViewVehicles = ({
    data,
    selectedId: selectedVehicleId,
    countByDrivingStatus,
    selectedFilter,
    setSelectedFilter,
    onSelect
}: SidebarProps<VehicleData> & { onSelect: (id: string) => void }) => {
    const { t } = useTranslation();

    const selectedVehicleGroupIds = useAppSelector((state) => state.monitorViewFilters.selectedVehicleGroupIds);

    const filteredData = useMemo(() => {
        if (selectedFilter === "All") return data;
        return data.filter((vehicle) => vehicle.driving === selectedFilter);
    }, [data, selectedFilter]);

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <VehicleFilters selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} countByDrivingStatus={countByDrivingStatus} />
                </Grid>
                <Grid item xs={12} display="flex" justifyContent="flex-end">
                    <VehicleGroupFilter selectedGroupIds={selectedVehicleGroupIds} setSelectedVehicleGroupIds={setSelectedVehicleGroupIds} />
                </Grid>
            </Grid >
            {filteredData?.length > 0 ? (
                filteredData.map((v) => (
                    <VehicleCard
                        key={v.vehicleId}
                        vehicle={v}
                        driver={v?.employeeName}
                        isSelected={v.vehicleId === selectedVehicleId}
                        onClick={() => onSelect(v.vehicleId)}
                    />
                ))
            ) : (
                <Alert variant="standard" severity="info">
                    {t("vehicle.noRows")}
                </Alert>
            )}
        </>
    );
};
